import React, { useEffect, useState } from 'react';
import { Col, Form, FormInstance, Grid, Message, Row, Schema } from "rsuite";
import FetchingSelect from '@/components/FetchingSelect';
import { FirstCityVisitAchievementType, UpsertFirstCityVisitAchievementType } from '@/models/achievement.model';
import { getCitiesLookup } from '@/services/city.service';

const modelSchema = Schema.Model<UpsertFirstCityVisitAchievementType>({
  cityId: Schema.Types.NumberType().isRequired('This field is required.'),
});
const emptyModel: UpsertFirstCityVisitAchievementType = {
  cityId: undefined,
};

interface FirstCityVisitFormProps{
  formObject?: FirstCityVisitAchievementType;
  onFormChange: (formValue: any) => void;
  formRef: React.Ref<FormInstance<Record<string, any>>>;
  loading: number;
}

const FirstCityVisitForm: React.FC<FirstCityVisitFormProps> = ({ formObject, onFormChange, formRef, loading }) => {
  const [formValue, setFormValue] = useState<UpsertFirstCityVisitAchievementType>(emptyModel);
  
  useEffect(() => {
    if (formObject) {
      setFormValue(formObject);
    } else {
      setFormValue(emptyModel);
    }
  }, [formObject]);

  useEffect(() => {
    onFormChange(formValue);
  }, [formValue]);
  
  return (
    <Form name='upsert-first-city' fluid
        ref={formRef}
        formValue={formValue}
        model={modelSchema}
        disabled={!!loading}
    >    
      <Grid w='100%' fluid>
        <Row>
          <Col span={{xs:24, lg:6}}>
            <Form.Group controlId="cityId">
              <Form.Label>City</Form.Label>
              <Form.Control name="cityId" accepter={FetchingSelect} block
                fetchData={(text, page) => getCitiesLookup(text, undefined, page)} 
                placeholder="Select a city"
                value={formValue.cityId}
                onChange={val=> setFormValue(pre => ({...pre, cityId: val}))}
              />   
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Message showIcon type="info">
            ...
          </Message>
        </Row>         
      </Grid>
    </Form>
  );
};

export default FirstCityVisitForm;